import { faArrowRotateLeft, faTrashCan } from '@fortawesome/pro-light-svg-icons'
import { HeaderElementTask } from '..'
import { useState } from 'react'
import ModalTaskDelete from './ModalTaskDelete'
import { UpdateTaskTy } from '../../types'

interface HeaderTaskDeleteProps {
    id: string
    message: string
    is_deleted: boolean
    onDeletedTask: () => Promise<void>
    updateTask: UpdateTaskTy
}

const HeaderTaskDelete: React.FC<HeaderTaskDeleteProps> = ({id, message, is_deleted, ...rest}) => {
    const { opened, setOpened } = useHeaderTaskDeleteLogic()
    return (
        <HeaderElementTask id={'delete_' + id} message={message} icon={is_deleted ? faArrowRotateLeft : faTrashCan} onClick={() => setOpened(true)}>
            {opened ? <ModalTaskDelete opened={true} setOpened={() => setOpened(null)} is_deleted={is_deleted} {...rest} /> : null }
        </HeaderElementTask>
    )
}

const useHeaderTaskDeleteLogic = () => {
    const [opened, setOpened] = useState<true | null>(null)

    return { opened, setOpened }
}

export default HeaderTaskDelete